import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

LUC.jsSlideshowClassic = {
    init: function ($section) {
        const swiper = new Swiper(".swiper", {
            modules: [Navigation, Pagination],
            direction: "vertical",
            loop: true,
            autoHeight: true,
            slidesPerView: "auto",
            autoplay: {
                delay: 4000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        function initializeCollectionSliders() {
            const collectionSliders = document.querySelectorAll("[data-collection-slider]");
            collectionSliders.forEach((slider) => {
                new Swiper(slider, {
                    slidesPerView: 1.2,
                    centeredSlides: false,
                    loop: true,
                    autoplay: false,
                    breakpoints: {
                        768: {
                            slidesPerView: 5,
                            spaceBetween: 24,
                            centeredSlides: false,
                        },
                    },
                });
            });
        }

        $(window).resize(function () {
            if ($(window).width() <= 768) {
                initializeCollectionSliders();
            }
        });

        if ($(window).width() <= 768) {
            initializeCollectionSliders();
        }
    },
    unload: function ($section) {},
};
